<template>
    <div class="form">

        <!-- Type -->
        <div class="form__section">
            <div class="form__title">Verkehrsmittelwahl</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrPills 
                        :values="data.meansOfTransport" 
                        :options="meansOfTransportOptions"
                        :tracking-data-label= "'Public Transport'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        @change="fieldChangeHandler($event, 'meansOfTransport')"
                    />
                </div>
            </div>
        </div>

        <!-- Avoid barriers options -->
        <div class="form__section">
            <div class="form__title">Barrierefreiheit</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.avoidBarriers" 
                        :options="avoidBarriersOptions"
                        :output-array="true"
                        @change="fieldChangeHandler($event, 'avoidBarriers')"
                    />
                </div>
            </div>
        </div>

        <!-- Max Changes -->
         <div class="form__section">
            <div class="form__title">Umstiege</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSelect 
                        :options="maxChangesOptions" 
                        :value="data.maxChanges" 
                        @change="fieldChangeHandler($event, 'maxChanges')"
                    />
                </div>
            </div>
        </div>

        <!-- Other options -->
        <div class="form__section">
            <div class="form__title">Weitere Optionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import {PUBLIC_MEANS_OF_TRANSPORT} from '@data/publicMeansOfTransport';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import SmrPills from '@/components/form/SmrPills.vue'
import SmrSelect from '@/components/form/SmrSelect.vue'

export default {
    components: {
        SmrChoiceGroup,
        SmrPills,
        SmrSelect,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            meansOfTransportOptions: PUBLIC_MEANS_OF_TRANSPORT,
            avoidBarriersOptions: [
                {value: 'STAIRS', label: 'Treppen vermeiden'},
                {value: 'ELEVATOR', label: 'Aufzüge vermeiden'},
                {value: 'ESCALATOR', label: 'Rolltreppen vermeiden'},
                // {value: 'LOWFLOOR', label: 'Nur Niederflurfahrzeuge verwenden'}, // todo: nothing about this field in API Docs
            ],
            maxChangesOptions: [
                {label: 'Nur Direktverbindungen', value: '0'},
                {label: 'Max. 1 x', value: '1'},
                {label: 'Max. 2 x', value: '2'},
                {label: 'Max. 3 x', value: '3'},
                {label: 'Beliebig', value: '-1'},
            ],
            otherOptions: [
                {value: 'bikeCarriage', label: 'Fahrradmitnahme möglich'},
            ],
        }
    },

}
</script>
